import React from 'react';
import './CareersOfficeContent.scss';
import OfficeContentRow from './OfficeContentRow/OfficeContentRow';

/**
 * Renders the careers office content module
 * @param {array} rows
 * @returns {JSX.Element}
 * @constructor
 */
const CareersOfficeContent = ({ rows }) => {
  const renderRows = (rows) => rows.map((row) => <OfficeContentRow {...row} />);

  return (
    <div className="c-careers-office-content background-color-gray">
      <div className="c-careers-office-content__inner">{renderRows(rows)}</div>
    </div>
  );
};

export default CareersOfficeContent;
